var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.languages),function(entry){return _c('a',{key:entry.title,staticClass:"language-button",style:(_vm.languageStyle(entry.language)),on:{"click":function($event){return _vm.changeLocale(entry.language)}}},[(entry.flag !== 'hu')?_c('flag',{attrs:{"iso":entry.flag,"squared":false,"title":entry.title}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }